import { setError } from 'src/fetch/common';
import _ from 'lodash';

/**
 * User Result 세팅
 */
export const dataSet = (data: any, error: any, errMsg?: string) => {
  // Set Error
  const errorSet = setError(data, error, errMsg);
  // const errorSet = { type: '' };
  const deepData = _.cloneDeep(data);
  const dataSet = deepData;

  const resultSet = {
    resError: errorSet,
    resData: deepData.data?.result,
  };
  return resultSet;
};

export const dataSetTotal = (data: any, error: any, errMsg?: string) => {
  // Set Error
  const errorSet = setError(data, error, errMsg);
  // const errorSet = { type: '' };
  const deepData = _.cloneDeep(data);
  const dataSet = deepData;
  const result = dataSet?.data?.result || [];

  result.forEach((item: any) => {
    let totalIncome = 0;

    const tsal_base = item.tsal_base || 0;
    const tsal_bonus = item.tsal_bonus || 0;
    const tsal_esop_withdrawal = item.tsal_esop_withdrawal || 0;
    const tsal_excess_exec_retire = item.tsal_excess_exec_retire || 0;
    const tsal_excess_invent_reward = item.tsal_excess_invent_reward || 0;
    const tsal_rbonus = item.tsal_rbonus || 0;
    const tsal_stkopt = item.tsal_stkopt || 0;

    totalIncome =
      tsal_base +
      tsal_bonus +
      tsal_esop_withdrawal +
      tsal_excess_exec_retire +
      tsal_excess_invent_reward +
      tsal_rbonus +
      tsal_stkopt;
    item.totalIncome = totalIncome;
  });

  const resultSet = {
    resError: errorSet,
    resData: deepData.data?.result,
  };
  return resultSet;
};

/**
 * User Result 세팅
 */
export const familyDataSet = (data: any, error: any, errMsg?: string) => {
  // Set Error
  const errorSet = setError(data, error, errMsg);
  const deepData = _.cloneDeep(data);
  const dataSet = deepData;
  const resultSet = {
    resError: errorSet,
    resData: deepData.data?.result,
  };
  return resultSet;
};
